const MODAL_TYPE = {
    SIGNIN: 'SIGNIN',
    SIGNUP: 'SIGNUP',
    EMAIL_VALIDATION: 'EMAIL_VALIDATION',
    NONE: 'NONE',
};

Hop.defineModule('invitation-signin-signup-modal', (root, params) => {
    const LOGGED_EVENT = 'invitation:logged';
    const modalType = params.modal || MODAL_TYPE.NONE;
    const invitationType = params.invitationType;
    const isMaltAdmin = params.isMaltAdmin;

    function openSigninSignupModal() {
        Hop.connect.control.showSigninPopup(root, false);
    }

    function openEmailValidationModal() {
        $('#emailValidationModal').modal('show');
    }

    function configureLoggedToRootElement() {
        root.setAttribute('data-send-event-when-logged-in', LOGGED_EVENT);

        if (modalType === MODAL_TYPE.SIGNUP) {
            root.setAttribute('data-show-signup-first', 'true');
        }
    }

    function bindClick() {
        root.addEventListener('click', onClick);
    }

    function bindEmailValidationModalEvent() {
        $('#emailValidationModal').on('shown.bs.modal', triggerHeapTracking);
    }

    function unbindEmailValidationModalEvent() {
        $('#emailValidationModal').off('shown.bs.modal', triggerHeapTracking);
    }

    function unbindClick() {
        root.removeEventListener('click', onClick);
    }

    function bindLoggedEvent() {
        Hop.events.on(LOGGED_EVENT, onLoggedIn);
    }

    function unbindLoggedEvent() {
        Hop.events.off(LOGGED_EVENT, onLoggedIn);
    }

    function bindEvents() {
        bindLoggedEvent();
        bindClick();
        bindEmailValidationModalEvent();
    }

    function unbindEvents() {
        unbindLoggedEvent();
        unbindClick();
        unbindEmailValidationModalEvent();
    }

    function submitForm() {
        root.click();
    }

    function onLoggedIn() {
        unbindEvents();
        submitForm();
    }

    function onClick(e) {
        e.preventDefault();
        openSigninSignupModal();
    }

    function triggerHeapTracking() {
        if (!window.heap) {
            return;
        }
        window.heap.track('InvitationEmailValidationModalShown');
    }

    function initialize() {
        if (modalType !== MODAL_TYPE.NONE) {
            configureLoggedToRootElement();
            bindEvents();

            if (modalType === MODAL_TYPE.SIGNUP && invitationType === 'LINK') {
                return;
            }

            if (modalType === MODAL_TYPE.EMAIL_VALIDATION) {
                openEmailValidationModal();
            } else if (!isMaltAdmin) {
                openSigninSignupModal();
            }
        }
    }

    initialize();

    return function destroy() {
        unbindEvents();
    };
});
